import { useQuery } from "@tanstack/react-query";
import { analyticsKeys } from "@/lib/query";
import type { AnalyticsPayload } from "@/lib/skills/analytics";

export function useAnalytics() {
  return useQuery({
    queryKey: analyticsKeys.all,
    queryFn: async (): Promise<AnalyticsPayload> => {
      const res = await fetch("/api/analytics");
      if (!res.ok) throw new Error("Failed to load analytics");
      const json: { data: AnalyticsPayload } = await res.json();
      return json.data;
    },
  });
}
